import { FC, PropsWithChildren } from "react";
import {
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Tooltip as RadixTooltip,
} from "@radix-ui/react-tooltip";

interface Props {
  text: string;
}

export const Tooltip: FC<PropsWithChildren<Props>> = ({ children, text }) => (
  <TooltipProvider>
    <RadixTooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className="rounded-b-sm bg-white p-3">
        {text}
        <TooltipArrow className="TooltipArrow" />
      </TooltipContent>
    </RadixTooltip>
  </TooltipProvider>
);
